import { render } from "./EditRegisterThemeModal.vue?vue&type=template&id=36fe12b6"
import script from "./EditRegisterThemeModal.vue?vue&type=script&lang=js"
export * from "./EditRegisterThemeModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__